// extracted by mini-css-extract-plugin
export default {"modal":"MP-z","addItemButton":"NP-z","plusCircle":"OP-z","branchVisible":"PP-z"};